import {Directive, ElementRef, ViewContainerRef} from "@angular/core";

@Directive({
  selector: '[int-native-element], [intNativeElement]'
})
export class IntNativeElementDirective {
  constructor(
    private readonly vcr: ViewContainerRef,
    readonly elementRef: ElementRef
  ) {
  }

}
